import script from "./site-map.vue?vue&type=script&lang=ts&setup=true"
export * from "./site-map.vue?vue&type=script&lang=ts&setup=true"

import "./site-map.vue?vue&type=style&index=0&id=1d474e67&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d474e67"]])

export default __exports__